import { OktaAuth } from './components/OktaAuth/OktaSignIn';
import { RequireAuth } from './components/PrivateRoute/RequireAuth';
import { AuthProvider, useAuth } from './components/AuthProvider/AuthProvider';
import { AccessDenied, AccessDeniedModal } from './components/AccessDenied';
import { requestInterceptor, responseInterceptor, fetchWithHeaders } from './api/interceptors';
import { SignInRoute } from './models';
import { Authentication } from './services/authentication.service';
import {
  useAuthProvider,
  useAuthState,
  $authState,
  useIsLoginInProgress,
  useErrorMessage,
  signInFx,
} from './store';

import type { AuthType, TokenInfo } from './models';

const authStores = { $authState };
const authEffects = { signInFx };

export {
  OktaAuth,
  RequireAuth,
  requestInterceptor,
  responseInterceptor,
  fetchWithHeaders,
  AuthType,
  TokenInfo,
  AccessDenied,
  AccessDeniedModal,
  SignInRoute,
  AuthProvider,
  useAuth,
  Authentication,
  useAuthProvider,
  useAuthState,
  useIsLoginInProgress,
  useErrorMessage,
  authEffects,
  authStores,
};
